import { lazy, Suspense } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";

const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const ChatBot = lazy(() => import("./components/ChatBot"));
const CookieConsent = lazy(() => import("./components/CookieConsent"));

const NotFound = lazy(() => import("./pages/NotFound"));
const PaidAdvertising = lazy(() => import("./pages/services/PaidAdvertising"));
const SocialMediaManagement = lazy(() => import("./pages/services/SocialMediaManagement"));
const EmailMarketing = lazy(() => import("./pages/services/EmailMarketing"));
const WebDesignCRO = lazy(() => import("./pages/services/WebDesignCRO"));
const ContentCreation = lazy(() => import("./pages/services/ContentCreation"));
const BrandingApparel = lazy(() => import("./pages/services/BrandingApparel"));
const StrategyConsulting = lazy(() => import("./pages/services/StrategyConsulting"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Suspense fallback={null}>
        <Toaster />
        <Sonner />
      </Suspense>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/services/paid-advertising" element={<PaidAdvertising />} />
            <Route path="/services/social-media" element={<SocialMediaManagement />} />
            <Route path="/services/email-marketing" element={<EmailMarketing />} />
            <Route path="/services/web-design" element={<WebDesignCRO />} />
            <Route path="/services/content-creation" element={<ContentCreation />} />
            <Route path="/services/branding-apparel" element={<BrandingApparel />} />
            <Route path="/services/strategy-consulting" element={<StrategyConsulting />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Suspense fallback={null}>
          <ChatBot />
        </Suspense>
        <Suspense fallback={null}>
          <CookieConsent />
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
